package com.milta.feature.auth.presentation

sealed interface OtpIntent {
    data class UpdateCode(val value: String) : OtpIntent
    object Verify : OtpIntent
    object Resend : OtpIntent
    object ClearError : OtpIntent
}
